import * as React from "react";
import { Avatar as AntdAvatar } from "antd";
import Avatar from "./avatar";


export default function AvatarGroup({
  children: propsChildren,
  maxCount: propsMaxCount,
  size: propsSize,
  tooltipContent: propsTooltipContent,
}) {
  return (
    <AntdAvatar.Group maxCount={propsMaxCount}>
      {propsChildren.map((user) => (
        <Avatar
          size={propsSize}
          key={user}
          name={user}
          tooltipContent={propsTooltipContent}
          noMargin
        />
      ))}
    </AntdAvatar.Group>
  );
}
